"use client";

import { useState, useEffect } from "react";
import Sidebar from "../../Component/Sidebar";
import IMAGES from "../../constants/images";
import { useDispatch, useSelector } from "react-redux";
import { getUserProfile } from "../../redux/action/Profile";
import { uploadFile } from "../../redux/api/Upload/Image";
import { updateProfile } from "../../redux/api/Organisation/update";
import { Upload } from "antd";
import Model from "../../Component/Model";
import SupportLegal from "../Profile/Support";

export default function Index() {
  const [collapsed, setCollapsed] = useState(false);

  // Settings navigation items

  return (
    <div className="flex bg-[#FFFFFF] min-h-screen mt-[80px]">
      {/* Main Sidebar */}
      <div
        className={`hidden lg:flex ${collapsed ? "w-[64px]" : "w-[272px]"} fixed top-0 left-0 h-[calc(100vh/var(--app-zoom))] z-20`}
      >
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>

      {/* Main Content */}
      <div
        className={`flex-1 min-w-0 bg-[#F8FAFC] pt-2 px-2 pb-8 transition-all duration-300 ${collapsed ? "lg:ml-[64px]" : "lg:ml-[272px]"
          }`}
      >
        {/* Settings Inner Sidebar - Mobile Horizontal Scroll */}

        <div className="flex">
          {/* Profile Content */}

          <div className="w-full bg-[#FFFFFF]">
            <main className="min-h-screen bg-[#FFFFFF]  w-full  ">
              <SupportLegal />
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}

function InfoField({ label, value, classNameLabel, classNameValue }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
      <div className={`${classNameLabel}`}>{label}</div>
      <div className={`md:col-span-2 font-medium text-right ${classNameValue}`}>
        {value}
      </div>
    </div>
  );
}
